var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HumanResourcesTable',_vm._g(_vm._b({attrs:{"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.positioncount.total",fn:function(ref){
var item = ref.item;
return [(item.positioncount)?_c('div',[_vm._v(_vm._s(_vm.displayNumber(item.positioncount.total)))]):_vm._e()]}},{key:"item.positioncount.nondbp",fn:function(ref){
var item = ref.item;
return [(item.positioncount)?_c('div',[_vm._v(_vm._s(_vm.displayNumber(item.positioncount.nondbp)))]):_vm._e()]}}])},'HumanResourcesTable',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }